import React from 'react';
import { PageFrame } from '../components/PageFrame';
import { features } from '../components/marketingContent';

type Props = {
  onPrimaryCta: () => void;
  onSecondaryCta: () => void;
};

export function FeaturesPage({ onPrimaryCta, onSecondaryCta }: Props) {
  return (
    <PageFrame title="Features" onPrimaryCta={onPrimaryCta} onSecondaryCta={onSecondaryCta}>
      <section id="features" className="section">
        <div className="container">
          <div className="section-heading">
            <div>
              <h1 className="section-title">Features</h1>
              <h2 className="section-subtitle">Built for analysts, quants, and risk in one pane.</h2>
            </div>
            <p className="section-description">
              A designed surface for the filing tape: fast scans, auditable insights, and delivery options that meet
              your workflow instead of adding one more dashboard tab.
            </p>
          </div>
          <div className="feature-grid">
            {features.map((feature) => (
              <div className="feature-card" key={feature.title}>
                <h3>{feature.title}</h3>
                <p>{feature.blurb}</p>
                <ul>
                  {feature.bullets.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>
    </PageFrame>
  );
}
